<template>
    <a
        @click="toggleHamburger"
    >
      <span/><span/><span/>
    </a>
</template>
<script>
export default {
  name: 'HamburgerMenu',
  methods: {
    toggleHamburger() {
      this.$emit('toggleHamburgerMenu');
    }
  }
}
</script>